module.exports = __webpack_public_path__ + "img/140.a81b9c0b.jpg";